import React from "react";
import Lottie from "lottie-react";
import medicalAnimation from "../Assets/animations/medical.json";

/**
 * Login Animation Component
 *
 * Displays a medical-themed animated logo on the login page
 * Uses Lottie animation for smooth, professional appearance
 */
const LoginAnimation = ({ size = 120 }) => {
  return (
    <div
      style={{
        width: size,
        height: size,
        margin: "0 auto",
      }}
      className="login-animation"
    >
      <Lottie animationData={medicalAnimation} loop={true} autoplay={true} />
    </div>
  );
};

export default LoginAnimation;
